<div class="main-contain p-1">
    <div class="sidenav-header">
        <div class="d-flex justify-space-between align-items-center heading">
            <h2>Email Settings</h2>
            <mat-icon class="close">close</mat-icon>
        </div>
    </div>
    <div class="sidenav-body pt-1">
        <mat-accordion [multi]="false">
            <mat-expansion-panel *ngFor="let section of sections; let first = first" [formGroup]="section.formGroup" [expanded]="first">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="d-flex align-items-center gap-10">
                            {{ section.label }}
                            <span *ngIf="section.moduleId !== 3" class="coming-soon-tag">Coming Soon</span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <ng-container *ngIf="section.moduleId === 3; else comingSoonBlock">
                    <div class="form-field d-flex align-items-center mb-1 mt-10">
                        <p class="m-0 w-150">Display Name</p>
                        <mat-form-field class="w-300">
                            <input
                                matInput
                                formControlName="displayName"
                                autocomplete="off"
                            />
                        </mat-form-field>
                    </div>
                    <div class="form-field d-flex align-items-center mb-1">
                        <p class="m-0 w-150">CC Address</p>
                        <ng-multiselect-dropdown
                            class="custom-multiselect w-300"
                            [placeholder]="'CC Address'"
                            [settings]="dropdownSettings"
                            [data]="dropdownList"
                            formControlName="ccAddress"
                            (onSelect)="onItemSelect($event)"
                            (onSelectAll)="onSelectAll($event)"
                            [disabled]="!section.isEditing"
                        >
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="form-field d-flex align-items-center mb-1">
                        <p class="m-0 w-150">Reply To Address</p>
                        <ng-multiselect-dropdown
                            class="custom-multiselect w-300"
                            [placeholder]="'Reply To Address'"
                            [settings]="replyToDropdownSettings"
                            [data]="replyToDropdownList"
                            formControlName="replyToAddress"
                            (onSelect)="onItemSelect($event)"
                            (onSelectAll)="onSelectAll($event)"
                            [disabled]="!section.isEditing"
                        >
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="d-flex align-items-center gap-15 mb-10">
                        <button
                            *ngIf="!section.isEditing"
                            mat-button
                            class="action-button primary-button border-radius-6"
                            (click)="editSection(section)"
                        >Edit</button>
                        <button
                            *ngIf="section.isEditing"
                            mat-button
                            class="action-button primary-button border-radius-6"
                            (click)="saveSection(section)"
                        >Save</button>
                        <button
                            *ngIf="section.isEditing"
                            mat-stroked-button
                            class="action-button border-radius-6"
                            (click)="cancelSection(section)"
                        >Cancel Changes</button>
                        <a href="javascript:void(0)" class="add" (click)="resetSection(section)">Reset to default</a>
                    </div>
                </ng-container>

                <ng-template #comingSoonBlock>
                    <div class="coming-soon-content">
                        <p class="m-0">Email settings for this module are coming soon.</p>
                    </div>
                </ng-template>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
